<template>
  <r-ai-page-container :current-step="2">
    <v-row class="text-start">
      <v-col cols="12">
        <div class="pb-4 text-body-1">
          {{ textIntro }}
        </div>
        <r-ai-bubble v-if="!isEditing">
          <ai-line title="Name" :text="nameText"></ai-line>
          <ai-line title="Address" :text="addressText"></ai-line>
        </r-ai-bubble>
        <r-ai-bubble v-if="isEditing" class="text-body-1 mt-2 mb-5">
          <v-text-field
            v-model="firstName"
            label="First Name"
            outlined
            dense
            class="mt-4"
          ></v-text-field>
          <v-text-field
            v-model="lastName"
            label="Last Name"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            v-model="city"
            label="City"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            v-model="state"
            label="State"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            v-model="country"
            label="Country"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            v-model="zipCode"
            label="Zip Code"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            v-model="addressLine1"
            label="Street Address (Optional)"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            v-model="addressLine2"
            label="Unit / Apt # (Optional)"
            outlined
            dense
          ></v-text-field>
        </r-ai-bubble>
        <div v-if="isEditing">
          <v-btn class="my-4" color="primary" outlined @click="save()" block>
            Save and Continue
          </v-btn>
        </div>
        <div class="pt-2" v-if="!isEditing">
          <v-btn class="my-4" color="primary" @click="next()" block>
            Looks Good
          </v-btn>
          <v-btn class="my-4 ai-outlined-btn" outlined @click="edit()" block>
            Edit or Add Info
          </v-btn>
          <v-btn
            class="my-4 ai-outlined-btn"
            outlined
            @click="saveAndExitToDone"
            block
          >
            Save and Exit Agent
          </v-btn>
          <!-- PR-AGENT-ESCAPE: small secondary link to the main resume
               editor. Data already saved by the underlying store + each
               section's save action, so this is a safe exit. Doesn't
               trigger the AIDone celebration — for users who decided the
               guided flow isn't for them and just want the regular UI. -->
          <div class="text-center mt-3">
            <a
              href="#"
              class="text-caption text--secondary"
              @click.prevent="$router.push('/information')"
            >
              Switch to manual entry
            </a>
          </div>
        </div>
      </v-col>
    </v-row>
  </r-ai-page-container>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import AILine from "../../components/AI/AILine.vue";

export default {
  name: "AINameAndAddress",
  components: {
    "ai-line": AILine
  },
  data: () => ({
    textIntro:
      "Thanks for uploading your resume! Does this general information look correct?",
    isEditing: false
  }),
  methods: {
    // PR-AGENT-UX: save before exiting so postal code + other edits aren't lost.
    async saveAndExitToDone() {
      try {
        await this.saveName();
        await this.saveAddress();
      } catch (e) {
        // best-effort save before exit; logging only
        console.warn("saveAndExitToDone failed:", e);
      }
      this.$router.push({ path: "/AIDone" });
    },
    next() {
      this.$router.push({ path: "/AITechSkills" });
    },
    edit() {
      this.isEditing = true;
    },
    save() {
      this.saveName();
      this.saveAddress();
      this.next();
    },
    ...mapActions("name", ["saveName"]),
    ...mapActions("address", ["saveAddress"])
  },
  computed: {
    nameText() {
      return `Name: ${this.nameDisplay}`;
    },
    addressText() {
      return `Address: ${this.addressDisplay}`;
    },
    ...mapFields("name", { nameDisplay: "displayValue" }),
    ...mapFields("address", { addressDisplay: "displayValue" }),
    ...mapFields("name", ["firstName", "lastName"]),
    // PR-AGENT-UX: postal code persistence bug. The store property is
    // `zipCode` (matches the FullResume model + Cosmos serialization).
    // The previous binding used `zip` which the store doesn't expose,
    // so edits never persisted — postal code disappeared on navigate-away.
    // Carlos's friend Michael reported this exact symptom.
    ...mapFields("address", [
      "country",
      "city",
      "state",
      "zipCode",
      "addressLine1",
      "addressLine2"
    ])
  }
};
</script>

<style scoped>
.edit-bubble {
  background-color: #f9fafb;
  border-radius: 10px;
  padding: 16px;
}
</style>
